var map = {
	"./CompactHeader.tsx": 54744,
	"./Footer.tsx": 66643,
	"./Header.tsx": 98009,
	"./HomePage.tsx": 30166,
	"./Layout.tsx": 79016,
	"./SharedContent.tsx": 7110,
	"./SignInPage.tsx": 18029,
	"./UnhandledErrorModal.tsx": 70052,
	"./VariantRootPage.tsx": 19226
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32507;